<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/headerImg/logo.png" alt="toplogo" />
        </div>
        <el-menu
          :default-active="this.$route.path"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#409eff"
          menu-trigger="hover"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/regarding/index">关于上鼎</el-menu-item>
          <el-submenu index="/product">
            <template slot="title">核心产品</template>
            <el-menu-item index="/product/dlzw">电流指纹</el-menu-item>
            <el-menu-item index="/product/tianxun">开源数据天询</el-menu-item>
            <el-menu-item index="/product/middleground">数据中台</el-menu-item>
          </el-submenu>
          <el-submenu index="/Solution">
            <template slot="title">解决方案</template>
            <el-menu-item index="/Solution/hjwl">慧集物联</el-menu-item>
            <el-menu-item index="/Solution/yqzn">营区智脑</el-menu-item>
          </el-submenu>
          <el-menu-item index="/contactUs">联系我们</el-menu-item>
        </el-menu>
        <div class="phone">
          <span class="el-icon-phone"> 021-56386078</span>
        </div>
      </el-header>
      <el-main>
        <router-view />

         <el-backtop 
          :bottom="100" 
          :right="50"
        >
        <div class="back-to-top">
          <i class="el-icon-download"></i>
        </div>
        </el-backtop>
      </el-main>
      <el-footer class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <span class="el-icon-phone"> 电话：021-56386078</span>
              <span class="el-icon-message"> 邮箱：hr@shu-ding.com</span>
              <span class="el-icon-location">
                地址：上海市嘉定区江桥镇武都路658号2号楼5层 /
                北京市海淀区永泰·自在香山80-1</span
              >
            </li>
          </ul>
          <ul class="content-nav1">
            <li>
              <span
                ><img src="./assets/footerImg/qrCode.png" alt="ercode"
              /></span>
              <span>扫一扫</span>
              <span>了解相关更多资讯</span>
            </li>
          </ul>
        </div>
        <div class="copyright">
          <img src="./assets/footerImg/img.png" alt="National" />
          <span>Copyright © 2023上鼎股份 | 备案号: 沪ICP备11028152号-1</span>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      isShow: false,
    };
  },
  methods: {},
};
</script>

<style>
.el-menu--popup {
  min-width: 120px !important;
  border-radius: 8px !important;
  text-align: center;
}
.el-menu .is-active {
  color: #2f6bff !important;
}
</style>

<style lang="scss" scoped>
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: unset !important;
}
::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  font-weight: 500 !important;
  font-size: 18px !important;
  color: #666666 !important;
  margin: 0 20px !important;
  padding: 0 !important;
}
::v-deep .is-active,
::v-deep .is-active .el-submenu__title {
  border-bottom-color: rgba(47, 107, 255, 1) !important;
}
::v-deep .el-backtop {
  width : 60px !important;
  height : 60px !important;
  font-size: 16px !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, .18) !important;
  .back-to-top {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .back-to-top i {
    font-size: 35px;
    transform: rotate(180deg);
  }
}
.el-header {
  display: flex;
  align-content: center;
  width: 100%;
  align-items: center;
  padding: 0 18.75%;
  height: 68px !important;
  position: relative;
  .logo {
    width: 110px;
    height: 36px;
    margin-right: 68px;
    img {
      width: 100%;
    }
  }
  .phone {
    position: absolute;
    right: 18.75%;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #2f6bff;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
.el-main {
  padding: 0 !important;
}
.footer {
  width: 100%;
  height: 265px !important;
  margin-top: 80px;
  background-color: #5f5f5f;
  padding: 0 18.75%;
  position: relative;
  &-content {
    width: 100%;
    height: calc(100% - 48px);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .content-nav {
      display: flex;
      justify-content: space-around;
      font-size: 20px;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;

        align-items: flex-start;
        p {
          font-size: 20px;
          color: #ffffff;
          padding: 10px 0;
        }
        span {
          color: #ffffff;
          font-weight: 300;
          padding: 7.5px 0;
        }
      }
    }
    .content-nav1 {
      list-style: none;
      margin: 0;
      padding: 0;
      color: #ffffff;
      font-size: 16px;
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // gap: 8px;
      }
    }
    img {
      width: 80px;
      height: 80px;
    }
  }
  .copyright {
    height: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 20px;
      height: 20px;
    }
    span {
      color: rgba(255, 255, 255, 0.5);
      line-height: 20px;
      margin-left: 10px;
    }
  }
}
</style>
